import { useRef } from "react";
import Bugsnag from "@bugsnag/js";
import logger from "./logger";
import dynamic from "next/dynamic";

function getSvgImported(name) {
  const customer = process.env.NEXT_PUBLIC_CUSTOMER;

  switch (customer) {
    case "lecloset":
      switch (name) {
        case "apple-logo":
          return import("../public/images/lecloset/dynamic-svg/apple-logo.svg");
        case "arrow-down-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-down-lg.svg");
        case "arrow-left-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-left-lg.svg");
        case "arrow-right-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-right-lg.svg");
        case "arrow-up-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-up-lg.svg");
        case "camera":
          return import("../public/images/lecloset/dynamic-svg/camera.svg");
        case "cart":
          return import("../public/images/lecloset/dynamic-svg/cart.svg");
        case "chat-circle-icon":
          return import("../public/images/lecloset/dynamic-svg/chat-circle-icon.svg");
        case "chevron-down":
          return import("../public/images/lecloset/dynamic-svg/chevron-down.svg");
        case "chevron-left":
          return import("../public/images/lecloset/dynamic-svg/chevron-left.svg");
        case "chevron-right":
          return import("../public/images/lecloset/dynamic-svg/chevron-right.svg");
        case "chevron-up":
          return import("../public/images/lecloset/dynamic-svg/chevron-up.svg");
        case "circle-error":
          return import("../public/images/lecloset/dynamic-svg/circle-error.svg");
        case "circle-info":
          return import("../public/images/lecloset/dynamic-svg/circle-info.svg");
        case "circle-success-tick":
          return import("../public/images/lecloset/dynamic-svg/circle-success-tick.svg");
        case "circle-warning":
          return import("../public/images/lecloset/dynamic-svg/circle-warning.svg");
        case "clock-icon":
          return import("../public/images/lecloset/dynamic-svg/clock-icon.svg");
        case "close":
          return import("../public/images/lecloset/dynamic-svg/close.svg");
        case "columns":
          return import("../public/images/lecloset/dynamic-svg/columns.svg");
        case "copy-icon":
          return import("../public/images/lecloset/dynamic-svg/copy-icon.svg");
        case "drawer_icon":
          return import("../public/images/lecloset/dynamic-svg/drawer_icon.svg");
        case "earth":
          return import("../public/images/lecloset/dynamic-svg/earth.svg");
        case "facebook":
          return import("../public/images/lecloset/dynamic-svg/facebook.svg");
        case "filter-and-order-icon":
          return import("../public/images/lecloset/dynamic-svg/filter-and-order-icon.svg");
        case "filters":
          return import("../public/images/lecloset/dynamic-svg/filters.svg");
        case "folder":
          return import("../public/images/lecloset/dynamic-svg/folder.svg");
        case "gift-icon":
          return import("../public/images/lecloset/dynamic-svg/gift-icon.svg");
        case "google-logo":
          return import("../public/images/lecloset/dynamic-svg/google-logo.svg");
        case "grid":
          return import("../public/images/lecloset/dynamic-svg/grid.svg");
        case "hamburger-menu":
          return import("../public/images/lecloset/dynamic-svg/hamburger-menu.svg");
        case "handshake":
          return import("../public/images/lecloset/dynamic-svg/handshake.svg");
        case "heart-empty":
          return import("../public/images/lecloset/dynamic-svg/heart-empty.svg");
        case "heart-full":
          return import("../public/images/lecloset/dynamic-svg/heart-full.svg");
        case "lightbulb":
          return import("../public/images/lecloset/dynamic-svg/lightbulb.svg");
        case "login-bracket":
          return import("../public/images/lecloset/dynamic-svg/login-bracket.svg");
        case "logout-bracket":
          return import("../public/images/lecloset/dynamic-svg/logout-bracket.svg");
        case "new-checkmark":
          return import("../public/images/lecloset/dynamic-svg/new-checkmark.svg");
        case "paperclip":
          return import("../public/images/lecloset/dynamic-svg/paperclip.svg");
        case "pause-icon":
          return import("../public/images/lecloset/dynamic-svg/pause-icon.svg");
        case "pen":
          return import("../public/images/lecloset/dynamic-svg/pen.svg");
        case "play-icon":
          return import("../public/images/lecloset/dynamic-svg/play-icon.svg");
        case "plus-icon":
          return import("../public/images/lecloset/dynamic-svg/plus-icon.svg");
        case "price-tag-icon":
          return import("../public/images/lecloset/dynamic-svg/price-tag-icon.svg");
        case "share-icon":
          return import("../public/images/lecloset/dynamic-svg/share-icon.svg");
        case "shipping-truck":
          return import("../public/images/lecloset/dynamic-svg/shipping-truck.svg");
        case "shower":
          return import("../public/images/lecloset/dynamic-svg/shower.svg");
        case "square":
          return import("../public/images/lecloset/dynamic-svg/square.svg");
        case "starEmpty":
          return import("../public/images/lecloset/dynamic-svg/starEmpty.svg");
        case "starFull":
          return import("../public/images/lecloset/dynamic-svg/starFull.svg");
        case "symbol-decrease":
          return import("../public/images/lecloset/dynamic-svg/symbol-decrease.svg");
        case "symbol-increase":
          return import("../public/images/lecloset/dynamic-svg/symbol-increase.svg");
        case "user-profile-suspended":
          return import("../public/images/lecloset/dynamic-svg/user-profile-suspended.svg");
        case "user-profile":
          return import("../public/images/lecloset/dynamic-svg/user-profile.svg");
        default:
          logger.info(`SVG with the name "${name}" does not exist for customer "lecloset".`);
          return import("../public/images/lecloset/dynamic-svg/lightbulb.svg");
      }
    case "lgd":
      switch (name) {
        case "apple-logo":
          return import("../public/images/lecloset/dynamic-svg/apple-logo.svg");
        case "arrow-down-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-down-lg.svg");
        case "arrow-left-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-left-lg.svg");
        case "arrow-right-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-right-lg.svg");
        case "arrow-up-lg":
          return import("../public/images/lecloset/dynamic-svg/arrow-up-lg.svg");
        case "camera":
          return import("../public/images/lecloset/dynamic-svg/camera.svg");
        case "cart":
          return import("../public/images/lecloset/dynamic-svg/cart.svg");
        case "chat-circle-icon":
          return import("../public/images/lecloset/dynamic-svg/chat-circle-icon.svg");
        case "chevron-down":
          return import("../public/images/lecloset/dynamic-svg/chevron-down.svg");
        case "chevron-left":
          return import("../public/images/lecloset/dynamic-svg/chevron-left.svg");
        case "chevron-right":
          return import("../public/images/lecloset/dynamic-svg/chevron-right.svg");
        case "chevron-up":
          return import("../public/images/lecloset/dynamic-svg/chevron-up.svg");
        case "circle-error":
          return import("../public/images/lecloset/dynamic-svg/circle-error.svg");
        case "circle-info":
          return import("../public/images/lecloset/dynamic-svg/circle-info.svg");
        case "circle-success-tick":
          return import("../public/images/lecloset/dynamic-svg/circle-success-tick.svg");
        case "circle-warning":
          return import("../public/images/lecloset/dynamic-svg/circle-warning.svg");
        case "clock-icon":
          return import("../public/images/lecloset/dynamic-svg/clock-icon.svg");
        case "close":
          return import("../public/images/lecloset/dynamic-svg/close.svg");
        case "columns":
          return import("../public/images/lecloset/dynamic-svg/columns.svg");
        case "copy-icon":
          return import("../public/images/lecloset/dynamic-svg/copy-icon.svg");
        case "drawer_icon":
          return import("../public/images/lecloset/dynamic-svg/drawer_icon.svg");
        case "earth":
          return import("../public/images/lecloset/dynamic-svg/earth.svg");
        case "facebook":
          return import("../public/images/lecloset/dynamic-svg/facebook.svg");
        case "filter-and-order-icon":
          return import("../public/images/lecloset/dynamic-svg/filter-and-order-icon.svg");
        case "filters":
          return import("../public/images/lecloset/dynamic-svg/filters.svg");
        case "folder":
          return import("../public/images/lecloset/dynamic-svg/folder.svg");
        case "gift-icon":
          return import("../public/images/lecloset/dynamic-svg/gift-icon.svg");
        case "google-logo":
          return import("../public/images/lecloset/dynamic-svg/google-logo.svg");
        case "grid":
          return import("../public/images/lecloset/dynamic-svg/grid.svg");
        case "hamburger-menu":
          return import("../public/images/lecloset/dynamic-svg/hamburger-menu.svg");
        case "handshake":
          return import("../public/images/lecloset/dynamic-svg/handshake.svg");
        case "heart-empty":
          return import("../public/images/lecloset/dynamic-svg/heart-empty.svg");
        case "heart-full":
          return import("../public/images/lecloset/dynamic-svg/heart-full.svg");
        case "lightbulb":
          return import("../public/images/lecloset/dynamic-svg/lightbulb.svg");
        case "login-bracket":
          return import("../public/images/lecloset/dynamic-svg/login-bracket.svg");
        case "logout-bracket":
          return import("../public/images/lecloset/dynamic-svg/logout-bracket.svg");
        case "new-checkmark":
          return import("../public/images/lecloset/dynamic-svg/new-checkmark.svg");
        case "paperclip":
          return import("../public/images/lecloset/dynamic-svg/paperclip.svg");
        case "pause-icon":
          return import("../public/images/lecloset/dynamic-svg/pause-icon.svg");
        case "pen":
          return import("../public/images/lecloset/dynamic-svg/pen.svg");
        case "play-icon":
          return import("../public/images/lecloset/dynamic-svg/play-icon.svg");
        case "plus-icon":
          return import("../public/images/lecloset/dynamic-svg/plus-icon.svg");
        case "price-tag-icon":
          return import("../public/images/lecloset/dynamic-svg/price-tag-icon.svg");
        case "share-icon":
          return import("../public/images/lecloset/dynamic-svg/share-icon.svg");
        case "shipping-truck":
          return import("../public/images/lecloset/dynamic-svg/shipping-truck.svg");
        case "shower":
          return import("../public/images/lecloset/dynamic-svg/shower.svg");
        case "square":
          return import("../public/images/lecloset/dynamic-svg/square.svg");
        case "starEmpty":
          return import("../public/images/lecloset/dynamic-svg/starEmpty.svg");
        case "starFull":
          return import("../public/images/lecloset/dynamic-svg/starFull.svg");
        case "symbol-decrease":
          return import("../public/images/lecloset/dynamic-svg/symbol-decrease.svg");
        case "symbol-increase":
          return import("../public/images/lecloset/dynamic-svg/symbol-increase.svg");
        case "user-profile-suspended":
          return import("../public/images/lecloset/dynamic-svg/user-profile-suspended.svg");
        case "user-profile":
          return import("../public/images/lecloset/dynamic-svg/user-profile.svg");
        default:
          logger.info(`SVG with the name "${name}" does not exist for customer "lgd".`);
          return import("../public/images/lecloset/dynamic-svg/lightbulb.svg");
      }
    default:
      logger.info(`Customer "${customer}" is not recognized for SVG import.`);
      return import("../public/images/lecloset/dynamic-svg/lightbulb.svg");
  }
}

function useDynamicSvgImport(name) {
  const ImportedIconRef = useRef();
  const ImportedNameRef = useRef();

  if (ImportedNameRef.current !== name) {
    ImportedNameRef.current = name;

    try {
      const importedIcon = dynamic(() => getSvgImported(name));
      ImportedIconRef.current = importedIcon;
    } catch (err) {
      Bugsnag.notify(new Error("Dynamic SVG missing"), (event) => {
        event.addMetadata("params", {
          svgName: name,
          customer: process.env.NEXT_PUBLIC_CUSTOMER,
          error: err?.message,
        });
      });
      logger.info("error while getting the svg!");
    }
  }

  return { loading: !ImportedIconRef.current, SvgComponent: ImportedIconRef.current };
}

export default useDynamicSvgImport;
